import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';

import { AspectRatioImage, getCloudinaryUrl } from '../../../Image';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardImage = (props: IngredientCardImageProps) => {
  const { source, ...restProps } = props;

  const formattedSource = getCloudinaryUrl(source, {
    crop: 'scale',
    width: 230,
  });

  return (
    <AspectRatioImage
      aspectRatioX={26}
      aspectRatioY={23}
      source={formattedSource}
      style={styles.image}
      {...restProps}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    overflow: 'hidden',
    borderRadius: theme.radius.large,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardImageProps = {
  source: string;
} & Omit<
  ComponentProps<typeof AspectRatioImage>,
  'aspectRatioX' | 'aspectRatioY'
>;
